import { render, staticRenderFns } from "./PassengerImportsPage.vue?vue&type=template&id=44d7d556&scoped=true"
import script from "./PassengerImportsPage.vue?vue&type=script&lang=ts"
export * from "./PassengerImportsPage.vue?vue&type=script&lang=ts"
import style0 from "./PassengerImportsPage.vue?vue&type=style&index=0&id=44d7d556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d7d556",
  null
  
)

export default component.exports